module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-video-home"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-video-top"
  }, [_vm._m(0), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("home.video.title")))]), _c('router-link', {
    staticClass: "view-more",
    attrs: {
      "to": {
        name: 'page_video'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("home.view_more")) + " >>")])], 1), _c('div', {
    staticClass: "box-video-search"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key_video),
      expression: "key_video"
    }],
    attrs: {
      "placeholder": _vm.$t('home.video.keyword')
    },
    domProps: {
      "value": (_vm.key_video)
    },
    on: {
      "keyup": _vm.onVideoChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key_video = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "addons-button-clear",
    style: (_vm.clear_video ? 'display:block;' : 'display:none;'),
    on: {
      "click": _vm.onVideoClear
    }
  }), _c('div', {
    staticClass: "addons-button",
    on: {
      "click": _vm.onVideoSearch
    }
  }, [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("search")])])])]), _c('div', {
    staticClass: "box-video-content"
  }, [(_vm.lstVideos.length) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.lstVideos), function(video, index) {
    return _c('div', [_c('FrontItem', {
      attrs: {
        "video": video,
        "obj_id": video.id
      }
    })], 1)
  }), _c('div', {
    staticClass: "clearfix"
  }), _c('router-link', {
    staticClass: "view-more mobile",
    attrs: {
      "to": {
        name: 'page_video',
        params: {
          front_top: 0
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("home.view_more")) + " >>")])], 2) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "no-data col-md-12 col-sm-12 col-xs-12"
  }, [_vm._v(_vm._s(_vm.no_data))])])])]), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "beehive"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/home/ic_video.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bc0e076","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/Body/Video/index.vue
// module id = 1634
// module chunks = 0